import { ProjectHeaderButton } from "@/containers/Project/components/ProjectHeader/styled";
import { routes } from "@/helpers";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBook } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "antd";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

interface IProps {
  projectId: string | undefined;
}

export const ProjectHistoryButton = ({ projectId }: IProps) => {
  const intl = useIntl();

  return (
    <Link to={routes.projects.history(projectId ?? "")}>
      <ProjectHeaderButton type="text" data-test-id="show-project-history">
        <Row justify="center">
          <FontAwesomeIcon size="xl" icon={faBook as IconProp} />
        </Row>
        <Row justify="center">
          {intl.formatMessage({ id: "project.historyTitle" })}
        </Row>
      </ProjectHeaderButton>
    </Link>
  );
};
